module.exports = __webpack_public_path__ + "static/media/8.52789f62.jpg";